module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden sm:block"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "w-64 border rounded-full p-2 px-4",
    attrs: {
      "type": "text",
      "placeholder": "Procurar..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "absolute pin-r pin-t p-2 mr-1 text-grey",
    on: {
      "click": function($event) {
        _vm.searchQuery = ''
      }
    }
  }, [_c('icon', {
    staticClass: "w-4 h-4",
    class: {
      'text-grey-darkest': _vm.searchQuery.length > 0
    },
    attrs: {
      "name": "x"
    }
  })], 1)]), _vm._v(" "), _c('portal', {
    attrs: {
      "to": "modal"
    }
  }, [(_vm.showSearch) ? _c('Modal', {
    attrs: {
      "width": "lg",
      "show": _vm.showSearch
    },
    on: {
      "close": _vm.close
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Pesquisa Rápida")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-wrap",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(!_vm.result.products.items.length) ? _c('div', [_vm._v("\n          Nenhum registo encontrado para com o critério de pesquisa:\n          "), _c('span', {
    staticClass: "bg-blue-lighter"
  }, [_c('b', [_c('i', [_vm._v(_vm._s(_vm.searchQuery))])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.result.products.items), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "md:w-1/3 items-center text-center mb-3 px-3"
    }, [_c('img', {
      attrs: {
        "src": product.image
      }
    }), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(product.name) + "\n          ")]), _vm._v(" "), _c('div', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.goToProduct(product.id)
        }
      }
    }, [_vm._v("\n              " + _vm._s(product.model) + "\n            ")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.formatPrice(product.price)))])])
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('ButtonBase', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Fechar")])], 1)]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46a15366","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global-search/GlobalSearch.vue
// module id = 567
// module chunks = 66